import { from, switchMap } from 'rxjs';

import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@ministrary/shared/services/auth/auth.service';
import { injectSupabase } from '@ministrary/shared/functions/inject-supabase.function';

export function jwtInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  const authService = inject(AuthService);
  const supabase = injectSupabase();

  return from(supabase.auth.getSession()).pipe(
    switchMap(({ data }) => {
      const token = data.session?.access_token;

      if (token) {
        if (data.session?.access_token !== authService.session$.getValue()?.access_token) {
          authService.session$.next(data.session ?? undefined);
        }

        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }

      return next(request);
    })
  );
}
